import {
  defaultBorders,
  defaultLayouts,
  defaultPadding,
  GSEmptyList,
  GSItemList,
} from "golfstatus_react_components";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
  updateCurrentPackage,
} from "../../../../reducers/tournamentSlice";
import {
  addTournamentPackageToOrderThunk,
  selectRegistrationOrder,
  clearNotifications
} from "../../../../reducers/registrationOrderSlice";
import PackageLineItem from "./package-line-item";
import { useTheme } from "../../../../hooks/themeHooks";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import {
  packageSoldOut,
  useCustomer,
  useTournament,
} from "../../../../hooks/tournamentHooks";
import { useEffect } from "react";
import { useGolfstatusNavigate } from "../../../../hooks/navigationHooks";


export const PLAYER_PACKAGES = "playerPackages";
export const TEAM_PACKAGES = "teamPackages";
export const SPONSOR_PACKAGES = "sponsorPackages";
export const ADD_ON_PACKAGES = "addOnPackages";

const PackageList = (props) => {
  const { packages, type } = props;

  const dispatch = useDispatch();
  const navigate = useGolfstatusNavigate();

  useEffect(() => {
    return () => {dispatch(clearNotifications())}
  },[dispatch])

  const [searchParams] = useSearchParams();

  const [, theme, getStyle] = useTheme();

  const tournament = useTournament();
  const registrationOrder = useSelector(selectRegistrationOrder);
  const {customer} = useCustomer()

  const isTeamRegistration = type === TEAM_PACKAGES || type === PLAYER_PACKAGES;

  const showWaitList =
    tournament.numberRegisteredTeams >= tournament.numberOfTeams &&
    isTeamRegistration &&
    tournament.hasWaitList;

  const viewPackage = (tournamentPackage) => {
    dispatch(updateCurrentPackage(tournamentPackage));
    navigate(`${tournamentPackage.id}?${searchParams.toString()}`);
  };

  const getPackageStyle = (tp) => {
    return tp.remainingPackages > 0
      ? getStyle(theme.surfaceVariant)
      : { ...getStyle(theme.surfaceVariant) };
  };

  const getPackageAction = (tp) => {
    if (showWaitList) {
      return {
        title: "Join Waitlist",
        type: "grey",
        buttonIcon: faPlus,
        onClick: (e) => {
          addPackageToCart(tp);
          e?.stopPropagation?.();
        },
      };
    }
    if (!packageSoldOut(tournament, tp)) {
      return {
        title: "Add To Cart",
        type: "",
        buttonIcon: faPlus,
        style: { ...getStyle(theme.tertiaryContainer), flexGrow: 1 },
        onClick: (e) => {
          addPackageToCart(tp);
          e?.stopPropagation?.();
        },
      };
    } else {
      return {
        title: "sold out",
        type: "black pill secondary",
      };
    }
  };

  const addPackageToCart = (currentPackage) => {
    const registrationOrderItem = {
      registrationOrder: { ...registrationOrder, tournament, registrationCustomer: customer },
      tournamentPackage: currentPackage,
      accessGroupMember: {id : registrationOrder?.accessGroupMemberID}
    };

    dispatch(addTournamentPackageToOrderThunk(registrationOrderItem));
  };

  const getWaitList = () => {
    return (
      <GSEmptyList
        style={{
          ...defaultLayouts.fullWidth,
          ...defaultPadding.emptyListPad,
          ...getStyle(theme.surfaceVariant),
          ...defaultBorders.mediumLargeBorderRadius,
        }}
        title="Sold Out!"
        detail="Join the waitlist to be notified as a spot opens up!"
        actions={[
          {
            title: "Join Waitlist",
            type: "black",
            buttonIcon: faPlus,
            onClick: () => {
              navigate(`waitlist?type=${type}`);
            },
          },
        ]}
      />
    );
  };

  if (showWaitList) {
    return getWaitList();
  }

  return (
    <package-list>
      <GSItemList
        style={{ ...defaultLayouts.fullWidth }}
        type="vertical selectable medium-large-gap"
        items={packages}
        itemSelected={(p) => {
          viewPackage(p);
        }}
        listItem={(tp) => (
          <PackageLineItem
            className="hover-color-shift"
            style={{
              ...defaultLayouts.fullWidth,
              ...defaultPadding.xLargePad,
              ...getPackageStyle(tp),
              ...defaultBorders.mediumLargeBorderRadius,
            }}
            {...tp}
            action={getPackageAction(tp)}
          />
        )}
      />
    </package-list>
  );
};

export default PackageList;
